if(!window.__PFP_PREMIUM_V4_LOADED){window.__PFP_PREMIUM_V4_LOADED=true;(()=>{
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;

  const bindOffer=root=>{
    const forms=root.querySelectorAll?.('.pfp-offer form,.pfp-sticky form')||[];
    forms.forEach(form=>{
      if(form.dataset.pfpAjaxBound==='true')return;
      form.dataset.pfpAjaxBound='true';
      form.addEventListener('submit',async event=>{
        event.preventDefault();
        if(!form.checkValidity()){form.reportValidity();return}
        const button=form.querySelector('button[type="submit"]');
        if(!button||button.disabled)return;
        const originalLabel=button.textContent;
        button.disabled=true;
        button.setAttribute('aria-busy','true');
        button.textContent='Wird hinzugefügt …';
        const formData=new FormData(form);
        const sectionIds=[...document.querySelectorAll('cart-items-component[data-section-id]')]
          .map(item=>item.dataset.sectionId)
          .filter(Boolean);
        const sections=[...new Set(sectionIds)].join(',');
        const quantity=Number(formData.get('quantity'))||1;
        const variantId=String(formData.get('id')||'');
        const isPunchFitBundle=variantId==='49801929523531';
        if(sectionIds.length)formData.set('sections',sections);
        formData.set('sections_url',window.location.pathname);
        const requestBody=isPunchFitBundle?JSON.stringify({
          items:[{id:53370832814411,quantity},{id:49801929523531,quantity}],
          sections,
          sections_url:window.location.pathname
        }):formData;
        try{
          const endpoint=window.Theme?.routes?.cart_add_url||'/cart/add.js';
          const response=await fetch(endpoint,{
            method:'POST',
            headers:{
              Accept:'application/json',
              'X-Requested-With':'XMLHttpRequest',
              ...(isPunchFitBundle?{'Content-Type':'application/json'}:{})
            },
            body:requestBody
          });
          const data=await response.json();
          if(!response.ok||data.status)throw new Error(data.description||data.message||'Das Produkt konnte nicht hinzugefügt werden.');
          const cartResponse=await fetch('/cart.js',{headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
          const cart=cartResponse.ok?await cartResponse.json():null;
          const source=form.closest('.pfp-sticky')?'pfp-sticky':'pfp-offer';
          const paidItemCount=Array.isArray(cart?.items)?cart.items.reduce((count,item)=>count+(String(item.variant_id)==='53370832814411'?0:Number(item.quantity)||0),0):0;
          form.dispatchEvent(new CustomEvent('cart:update',{
            bubbles:true,
            detail:{resource:cart||{},sourceId:source,data:{
              source:'pfp-cart-sync',
              itemCount:paidItemCount,
              variantId:String(formData.get('id')||''),
              sections:data.sections||{}
            }}
          }));
          const ensureDrawerOpen=()=>{
            const drawer=document.querySelector('cart-drawer-component');
            const dialog=drawer?.querySelector('dialog');
            if(dialog?.open)return;
            drawer?.querySelector(':scope > button[on\\:click="/open"]')?.click();
            if(dialog&&!dialog.open&&typeof dialog.showModal==='function'){
              try{dialog.showModal()}catch(_){}
            }
          };
          ensureDrawerOpen();
          window.setTimeout(ensureDrawerOpen,80);
          button.textContent='Im Warenkorb';
          setTimeout(()=>{if(button.isConnected)button.textContent=originalLabel},1800);
        }catch(error){
          console.error(error);
          button.textContent=error.message||'Bitte erneut versuchen';
          setTimeout(()=>{if(button.isConnected)button.textContent=originalLabel},2500);
        }finally{
          button.disabled=false;
          button.removeAttribute('aria-busy');
        }
      });
    });
  };

  const offerAnchorSelector='a[href="#angebot"]';
  const offerHeaderOffset=()=>{
    const announcementHeight=document.querySelector('.announcement-bar')?.parentElement?.getBoundingClientRect().height||0;
    const headerHeight=document.querySelector('.header-section')?.getBoundingClientRect().height||0;
    return Math.round(announcementHeight+headerHeight)+12;
  };
  const scrollToOffer=target=>{
    const move=()=>{
      const root=document.documentElement;
      const previous=root.style.scrollBehavior;
      const top=Math.max(0,window.scrollY+target.getBoundingClientRect().top-offerHeaderOffset());
      root.style.scrollBehavior='auto';
      window.scrollTo(0,top);
      root.style.scrollBehavior=previous;
    };
    move();
    window.setTimeout(move,120);
    window.setTimeout(move,520);
  };
  const bindOfferLinks=root=>{
    const links=root.querySelectorAll?.(offerAnchorSelector)||[];
    links.forEach(link=>{
      if(link.dataset.pfpOfferLinkBound==='true')return;
      link.dataset.pfpOfferLinkBound='true';
      link.addEventListener('click',event=>{
        event.preventDefault();
        event.stopPropagation();
        const target=document.getElementById('angebot');
        if(!target)return;
        if(window.location.hash!=='#angebot')history.replaceState(null,'','#angebot');
        scrollToOffer(target);
      },true);
    });
  };

  const bindGalleries=root=>{
    const galleries=root.querySelectorAll?.('[data-pfp-gallery]')||[];
    galleries.forEach(gallery=>{
      if(gallery.dataset.pfpGalleryBound==='true')return;
      gallery.dataset.pfpGalleryBound='true';
      const track=gallery.querySelector('[data-pfp-gallery-track]');
      const slides=[...gallery.querySelectorAll('[data-pfp-gallery-slide]')];
      const thumbs=[...gallery.querySelectorAll('[data-pfp-gallery-thumb]')];
      const current=gallery.querySelector('[data-pfp-gallery-current]');
      const previous=gallery.querySelector('[data-pfp-gallery-prev]');
      const next=gallery.querySelector('[data-pfp-gallery-next]');
      if(!track||slides.length<2)return;
      let active=0;
      let frame=0;
      const update=index=>{
        active=Math.max(0,Math.min(slides.length-1,index));
        thumbs.forEach((thumb,i)=>{
          if(i===active)thumb.setAttribute('aria-current','true');
          else thumb.removeAttribute('aria-current');
        });
        if(current)current.textContent=String(active+1);
        if(previous){
          previous.hidden=active===0;
          previous.disabled=active===0;
        }
        if(next){
          next.hidden=active===slides.length-1;
          next.disabled=active===slides.length-1;
        }
      };
      const go=index=>{
        const target=Math.max(0,Math.min(slides.length-1,index));
        track.scrollTo({left:track.clientWidth*target,behavior:reduce?'auto':'smooth'});
        update(target);
      };
      previous?.addEventListener('click',()=>go(active-1));
      next?.addEventListener('click',()=>go(active+1));
      thumbs.forEach((thumb,i)=>thumb.addEventListener('click',()=>go(i)));
      track.addEventListener('scroll',()=>{
        cancelAnimationFrame(frame);
        frame=requestAnimationFrame(()=>update(Math.round(track.scrollLeft/Math.max(track.clientWidth,1))));
      },{passive:true});
      update(0);
    });
  };

  let stickyHeroObserver;
  const bindStickyVisibility=()=>{
    stickyHeroObserver?.disconnect();
    const stickies=[...document.querySelectorAll('[data-pfp-sticky]')];
    if(!stickies.length)return;
    const hero=document.querySelector('.pfp-hero');
    const update=()=>{
      const beforeHeroEnd=!!hero&&hero.getBoundingClientRect().bottom>0;
      stickies.forEach(sticky=>{sticky.hidden=beforeHeroEnd});
    };
    update();
    if(hero){
      stickyHeroObserver=new IntersectionObserver(update,{threshold:0});
      stickyHeroObserver.observe(hero);
    }
  };

  const prepare=root=>{
    bindOfferLinks(root);
    bindGalleries(root);
    bindOffer(root);
    const sticky=root.querySelector?.('[data-pfp-sticky]');
    if(sticky&&!window.Shopify?.designMode&&sticky.parentElement!==document.body)document.body.appendChild(sticky);
    bindStickyVisibility();
  };

  window.addEventListener('pageshow',bindStickyVisibility);
  document.addEventListener('shopify:section:reorder',bindStickyVisibility);
  prepare(document);
  document.addEventListener('shopify:section:load',event=>prepare(event.target));
})();}